"use client";

import { ServerError } from "@caffeina-siad/ui-kit/src/components/organisms";
import BaseLayout from "@/layouts/BaseLayout";

export default function ErrorPage() {
  return (
    <BaseLayout>
      <ServerError />
    </BaseLayout>
  );
}
